import React from "react";
import "./About.css"; // Import CSS file

const features = [
  { icon: "🇹🇳", text: "Made in TamilNadu" },
  { icon: "👍", text: "Assured Quality" },
  // { icon: "💰", text: "Cash On Delivery" },
  { icon: "🚚", text: "Free Shipping" },
  { icon: "📦", text: "7 Day Returns" },
  { icon: "🖨️", text: "Custom Printing" },
];

const About = () => {
  return (
    <div className="about-container">
      {features.map((feature, index) => (
        <div key={index} className="feature-box">
          <span className="feature-icon">{feature.icon}</span>
          <span className="feature-text">{feature.text}</span>
        </div>
      ))}
    </div>
  );
};

export default About;
